/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { StyledLoadingMessage } from "src/components/Block/styles";
import { Mono } from "src/components/Layout/Typography";

interface Props {
  uploadPercent?: number;
}

export function UploadProgress({ uploadPercent }: Props) {
  return (
    <StyledLoadingMessage>
      <p>Uploading...</p>
      <Mono>{uploadPercent && `${Math.min(uploadPercent, 99).toFixed(0)}%`}</Mono>
    </StyledLoadingMessage>
  );
}
